/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomOtherProfessionalsRelationshipsItem/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Avatar from './Avatar/index'
import ContactInfo from './ContactInfo/index'
import Edit from './Edit/index'
import Menu from './Menu/index'
import Name from './Name/index'
import OfficeName from './OfficeName/index'
import Profession from './Profession/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomOtherProfessionalsRelationshipsItem({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsRelationshipsItem"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="DataVaxiomOtherProfessionalsRelationshipsItem.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-NVBrk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-NVBrk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-NVBrk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-4-NVBrk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="DataVaxiomOtherProfessionalsRelationshipsItem.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
/>
<div
  data-testid="DataVaxiomOtherProfessionalsRelationshipsItem.Vertical"
  data-view-path={viewPath}
 style={{'--ml-5-NVBrk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<OfficeName
  viewPath={`${viewPath}/OfficeName`}
/>
</div>
</div>
<Profession
  viewPath={`${viewPath}/Profession`}
/>
<ContactInfo
  viewPath={`${viewPath}/ContactInfo`}
/>
<div
  data-testid="DataVaxiomOtherProfessionalsRelationshipsItem.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Menu
  viewPath={`${viewPath}/Menu`}
/>
</div>
</div>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
{children}
</React.Fragment>)
}